import {
    ConflictType,
    WorkFileSimpleResponseDto,
    WorkFileStatuses,
} from '../_generated/api/workfile-import'
import { nullableDate } from './ApiLifeCycleModel'
import ApiModel from './ApiModel'
import WorkfileConflict from './WorkfileConflict'

export default class Workfile extends ApiModel<WorkFileSimpleResponseDto> {
    get id() {
        return this.data.id ?? ''
    }

    get tenantId() {
        return this.data.tenantId ?? ''
    }

    get generatedAt() {
        return nullableDate(this.data.generatedAt)
    }

    get generatedBy() {
        return this.data.generatedBy ?? ''
    }

    get uploadedAt() {
        return nullableDate(this.data.uploadedAt)
    }

    get uploadedBy() {
        return this.data.uploadedBy ?? ''
    }

    get fileName() {
        return this.id ?? ''
    }

    get status() {
        return this.data.status ?? WorkFileStatuses.Unknown
    }

    get conflict() {
        const { unresolvedConflicts } = this.data
        const conflict = unresolvedConflicts?.[0]
        if (!conflict) return undefined
        return new WorkfileConflict(conflict)
    }

    get totalRecords() {
        return this.data.totalRecords ?? 0
    }

    get processedRecords() {
        return this.data.processedRecords ?? 0
    }

    get progress() {
        return this.processedRecords / this.totalRecords
    }
}
